{
	"title": "Τιμολόγια",
	"buttonShowMoreInvoicesTitle": "Εμφάνιση περισσότερων τιμολογίων",
	"invoicesTableHeaders": {
		"date": "Ημερομηνία",
		"invoiceNumber": "Αριθμός τιμολογίου",
		"deliveredQuantity": "Παραδοθείσα ποσότητα",
		"bundledCarbonSavings": "Ομαδοποιημένες μειώσεις άνθρακα",
		"transactionId": "Αναγνωριστικό συναλλαγής"
	},
	"errorMessage": "Η φόρτωση των τιμολογίων απέτυχε"
}
